import { useRecoilState } from 'recoil';
import { popupState } from '../recoil/state';
import Logout from '../assets/icons/Logout.svg';

const usePopup = () => {
    const [popup, setPopup] = useRecoilState(popupState);
    const { open, icon, heading, message, onConfirm, onClose } = popup;

    const openPopup = (heading, message, icon, onConfirm = () => { }, onCancel = () => { }) => {
        const iconPaths = {
            logout: Logout,
            download: '/icons/tabs/Download.svg',
            view: '/icons/tabs/SuccessPurple.svg',
            delete: '/icons/tabs/Delete.svg',
            edit: '/icons/tabs/Edit.svg'
        };

        const iconPath = iconPaths[icon] || null;
        setPopup({
            open: true,
            icon: iconPath,
            heading: heading,
            message: message,
            onConfirm: onConfirm,
            onClose: () => { onCancel(); setPopup({ ...popup, open: false }) },
        });
    };

    const closePopup = () => setPopup({ open: false });

    return {
        open,
        icon,
        message,
        heading,
        onConfirm,
        onClose,
        openPopup,
        closePopup
    };
};

export default usePopup;